import { Reveal } from "@components/ui";

const certifications = [
  {
    label: "Dubai Civil Defense",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 md:w-5 md:h-5">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  {
    label: "ESMA Certified",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 md:w-5 md:h-5">
        <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    ),
  },
  {
    label: "UAE Fire Safety Code",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" className="w-4 h-4 md:w-5 md:h-5">
        <path d="M12 22c3.5 0 6-2.5 6-6 0-4-3-7-6-10-3 3-6 6-6 10 0 3.5 2.5 6 6 6z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
];

export function CertifiedSection() {
  return (
    <section className="w-full bg-[#122d63] overflow-hidden relative py-10 md:py-14 lg:py-[80px] px-5 md:px-10 lg:px-[180px]">
      {/* Top gradient accent bar */}
      <div className="absolute top-0 left-0 right-0 h-[4px] bg-gradient-to-r from-[#f24d2b] via-[#ff8a65] to-[#122d63]" />

      {/* Decorative watermark */}
      <svg
        viewBox="0 0 24 24"
        fill="none"
        className="absolute top-8 right-10 md:right-20 lg:right-[180px] w-[100px] h-[100px] md:w-[160px] md:h-[160px] text-white/[0.03] pointer-events-none"
      >
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="0.5" fill="currentColor" />
      </svg>

      <div className="w-full max-w-[1368px] mx-auto relative">
        <Reveal direction="up">
          <div className="flex flex-col gap-5 md:gap-6">
            {/* Badge + Icon */}
            <div className="flex items-center gap-3">
              <div className="w-9 h-9 md:w-10 md:h-10 rounded-[10px] bg-white/10 flex items-center justify-center text-white">
                <svg viewBox="0 0 24 24" fill="none" className="w-5 h-5">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <span className="inline-block px-3.5 py-1 rounded-full bg-white/10 text-white text-[12px] md:text-[14px] font-semibold tracking-[-0.02em] uppercase">
                Certified & Compliant
              </span>
            </div>

            {/* Heading */}
            <h2 className="text-[24px] md:text-[36px] lg:text-[48px] tracking-[-0.04em] font-semibold text-white font-albert-sans leading-[1.1]">
              Certified. Regulated. Compliant.
            </h2>

            {/* Description */}
            <p className="max-w-[900px] text-[14px] md:text-base lg:text-[20px] tracking-[-0.04em] text-white/70 font-albert-sans leading-[1.5]">
              GASIS is fully licensed and certified by Dubai Civil Defense and
              the Emirates Authority for Standardization and Metrology (ESMA).
              All connections are tested and commissioned in accordance with UAE
              Fire Safety Code of Practice.
            </p>

            {/* Certification badges */}
            <div className="flex flex-wrap gap-2.5 md:gap-3 pt-1">
              {certifications.map((cert) => (
                <div
                  key={cert.label}
                  className="flex items-center gap-2 px-3.5 py-2 md:px-4 md:py-2.5 rounded-[10px] bg-white/[0.08] border border-white/[0.12] text-white hover:bg-white/[0.14] hover:border-white/[0.22] transition-all duration-300"
                >
                  {cert.icon}
                  <span className="text-[12px] md:text-[14px] font-medium tracking-[-0.02em] whitespace-nowrap">
                    {cert.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
